module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/daiwa-living-39a59980b6ea38d95bfe9948bf9c5014.png";